<template>
    <div class="loading-container">
        <loading :active="loading" :is-full-page="false" />
        <template v-if="!loading">
            <div class="task-body">
                <JobLink :companyId="job.companyId" :executiveId="job.executiveId" />

                <h2>Job Ended</h2>

                <dl>
                    <dt>Confirmed Date</dt>
                    <dd>{{ jobHistoryConfirmedDate }}</dd>
                    <dt>Company Name</dt>
                    <dd>{{ company.name }}</dd>
                </dl>

                <form @submit.prevent>
                    <mt-input type="date" v-model="job.startDate" label="Start Date" @update:modelValue="markChanged" />
                    <mt-input type="date" v-model="job.endDate" label="End Date" @update:modelValue="markChanged" />
                    <mt-checkbox v-model="job.active" label="Active" @update:modelValue="markChanged" />
                </form>

                <InputError :errorMessage="errors" />
            </div>

            <div class="task-actions">
                <button @click="completeTask" class="primary">Complete</button>
            </div>
        </template>
    </div>
</template>

<script>
import TaskService from '@/services/manage/taskService'
import JobsService from '@/services/manage/JobsService'
import InputError from '@/components/shared/forms/input-error'
import CompanyService from '@/services/manage/companyService'
import JobLink from '@/components/manage/tasks/Jobs/JobLink'
import { Status } from '@/utils/request'
import ExecutiveService from '@/services/manage/executiveService'

export default {
    components: { JobLink, InputError },
    props: {
        task: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            changed: false,
            errors: [],
        }
    },
    computed: {
        executiveId() {
            return this.task.primaryEntityId
        },
        jobId() {
            return this.task.secondaryEntityId
        },
        loading() {
            return (
                this.$asyncComputed.company.updating ||
                this.$asyncComputed.job.updating ||
                this.$asyncComputed.jobHistoryConfirmedDate.updating
            )
        },
    },
    asyncComputed: {
        company: {
            async get() {
                if (this.job?.companyId) {
                    return await CompanyService.get(this.job.companyId)
                }

                return {}
            },
            default() {
                return {}
            },
        },
        job: {
            async get() {
                let job = await JobsService.get(this.jobId)

                return {
                    ...job,
                    startDate: job.startDate?.substring(0, 10),
                    endDate: job.endDate?.substring(0, 10),
                }
            },
            default() {
                return {}
            },
        },
        jobHistoryConfirmedDate: {
            async get() {
                return await ExecutiveService.getJobHistoryConfirmedDate(this.executiveId)
            },
            default: null,
        },
    },

    methods: {
        markChanged() {
            this.changed = true
        },
        async completeTask() {
            if (this.changed) {
                let { ok, status, content } = await JobsService.update(this.jobId, this.job)

                if (!ok) {
                    if (status === Status.UNPROCESSABLE_ENTITY) {
                        this.$flash('An error occurred when updating this job.', 'error')
                        this.errors = Object.values(content).flat()
                    } else {
                        this.$flash('An unknown error occurred when updating this job.', 'error')
                    }

                    return
                }
            }

            await TaskService.complete(this.task)
            this.$flash('Job updated successfully.', 'success')
        },
    },
}
</script>
